<script>
import WorkOrdersPerItemModal from '../work-orders-per-item';

export default {
  components: {
    WorkOrdersPerItemModal,
  },
  props: {
    workOrderItem: Object,
    item: Object,
  },
  methods: {
    reserveWOItem(quantity) {
      let newRequestedQuantity = -1;

      let {
        totalQuantity,
        consumedQuantity,
        orderedQuantity,
        requestedQuantity,
      } = this.workOrderItem;

      if (
        requestedQuantity > 0 &&
        totalQuantity <
          quantity + consumedQuantity + orderedQuantity + requestedQuantity
      ) {
        newRequestedQuantity =
          totalQuantity - quantity - consumedQuantity - orderedQuantity;
      }

      let apiWrapper = {
        requestedQuantity: newRequestedQuantity,
        reservedQuantity: quantity,
      };

      this.$emit('request-reserve', apiWrapper);
    },
  },
  computed: {
    itemsAvailable() {
      if (this.item == null || this.workOrderItem == null) {
        return 0;
      }

      return this.toFloat(
        this.item.totalQuantity -
          this.item.reservedQuantity +
          this.workOrderItem.reservedQuantity
      );
    },
    itemsNeeded() {
      if (this.workOrderItem == null) {
        return 0;
      }
      let { totalQuantity, consumedQuantity, orderedQuantity } =
        this.workOrderItem;
      return totalQuantity - consumedQuantity - orderedQuantity;
    },
    itemsLeft() {
      return this.toFloat(this.itemsAvailable - this.itemsNeeded);
    },
  },
};
</script>


<template>
  <b-container>
    <b-row>
      <b-col>
        <table class="table table-hover bigger-text-size">
          <thead class="thead-light">
            <tr>
              <th class="table-row-expandable">
                {{ $t('items.item') }}
              </th>
              <th class="table-row-relative">
                {{ $t('items.availables') }}
              </th>
              <th class="table-row-relative">
                {{ $t('items.reserved') }}
              </th>
              <th class="table-row-relative">
                {{ $t('items.total') }}
              </th>
              <th class="table-row-relative">
                {{ $t('general.manage') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="table-row-expandable">
                {{ item.name }}
              </td>
              <td class="table-row-relative">
                {{ itemsAvailable }}
              </td>
              <td class="table-row-relative">
                {{
                  toFloat(
                    item.reservedQuantity - workOrderItem.reservedQuantity
                  )
                }}
              </td>
              <td class="table-row-relative">
                {{ item.totalQuantity }}
              </td>
              <td class="table-row-relative">
                <i
                  class="fas fa-cogs text-success mr-1"
                  v-b-modal.work-orders-per-item-modal
                  style="cursor: pointer; font-size: 1.3em"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h3 v-if="itemsLeft >= 0">
          {{ $t('inventory.sufficient') }}
        </h3>
        <h3 v-else>{{ $t('inventory.insufficient') }}</h3>
      </b-col>
    </b-row>
    <b-row v-if="itemsAvailable > 0">
      <b-col>
        <b-button
          @click="reserveWOItem(itemsLeft >= 0 ? itemsNeeded : itemsAvailable)"
          block
          size="lg"
          :variant="itemsLeft >= 0 ? 'success' : 'warning'"
        >
          {{
            $t('items.reserveXItems').replace(
              '#',
              itemsLeft >= 0 ? itemsNeeded : itemsAvailable
            )
          }}
        </b-button>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-button block disabled size="lg" variant="secondary">{{
        $t('items.noItemAvailable')
      }}</b-button>
    </b-row>
    <b-row>
      <b-col>
        <small
          :class="{
            'text-muted': itemsLeft >= item.minQuantity,
            'text-danger': itemsLeft < item.minQuantity,
            'bigger-text-size': true,
          }"
        >
          {{
            $t('inventory.itemsLeft').replace(
              '#',
              itemsLeft >= 0 ? itemsLeft : 0
            )
          }}
        </small>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-center">
        <b-link
          href="#"
          class="bigger-text-size"
          @click="$emit('order-section')"
        >
          {{ $t('items.processInOrder') }}
        </b-link>
      </b-col>
    </b-row>
    <WorkOrdersPerItemModal
      v-if="workOrderItem != null"
      :itemIdPublic="workOrderItem.itemIdPublic"
      :workOrderIdPublic="workOrderItem.idPublic"
      :typeItem="1"
      @modal-closed="$emit('refresh-items')"
    />
  </b-container>
</template>

<style scoped>
.bigger-text-size {
  font-size: 1.1em;
}
</style>